import { useState, useCallback } from "react";
import { useAuth } from "@/contexts/AuthContext";

const STORAGE_KEY = "staff_industry_view";

export const INDUSTRY_OPTIONS = [
  { value: "security", label: "Security" },
  { value: "cleaning", label: "Commercial Cleaning" },
  { value: "event-staffing", label: "Event Staffing" },
  { value: "private-investigation", label: "Private Investigation" },
  { value: "landscaping", label: "Landscaping & Groundskeeping" },
  { value: "pest-control", label: "Pest Control" },
  { value: "facilities-maintenance", label: "Facilities Maintenance" },
  { value: "property-management", label: "Property Management Services" },
  { value: "it-managed-services", label: "IT Managed Services" },
  { value: "home-services", label: "Home Services" },
  { value: "construction-services", label: "Construction Services" },
  { value: "power-washing", label: "Power Washing" },
] as const;

export type IndustryValue = typeof INDUSTRY_OPTIONS[number]["value"];

export const useStaffIndustryView = () => {
  const { isSuperAdmin, isSupportRole, profile } = useAuth();
  const isStaffOrAdmin = isSuperAdmin || isSupportRole;

  const [activeIndustry, setActiveIndustryState] = useState<string>(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return stored;
    }
    return (profile as any)?.industry || "security";
  });

  const setActiveIndustry = useCallback((industry: string) => {
    setActiveIndustryState(industry);
    localStorage.setItem(STORAGE_KEY, industry);
  }, []);

  // For staff/admin, use the override; for regular users, use profile industry
  const effectiveIndustry = isStaffOrAdmin
    ? activeIndustry
    : (profile as any)?.industry || "security";

  return {
    isStaffOrAdmin,
    activeIndustry,
    setActiveIndustry,
    effectiveIndustry,
    industryOptions: INDUSTRY_OPTIONS,
  };
};
